import { useApi } from 'lib/contexts/ApplicationState';
import { useState } from 'react';
import { Concept } from 'lib/types/projects';

interface Props {
  concept: Concept;
}

export const ConceptStatus = ({
  concept,
}: Props) => {
  const API = useApi();
  const [_status, setStatus] = useState(concept.status || 'new');

  const getColor = () => {
    if (_status === 'used') {
      return 'bg-green';
    } if (_status === 'pitched') {
      return 'bg-orange';
    }
    return 'bg-teal';
  };

  const handleChange = async (newStatus: string) => {
    if (!concept.id) return;

    setStatus(newStatus);
    await API.updateConcept(concept.id, {
      ...concept,
      status: newStatus,
    });
  };

  return (
    <div>
      <select
        id="status"
        defaultValue="new"
        className={`${getColor()} pl-2 w-24 text-center font-bold text-white`}
        onChange={(e) => handleChange(e.target.value)}
        value={_status}
      >
        <option value="new">
          ----
        </option>
        <option value="pitched">
          pitched
        </option>
        <option value="used">
          used
        </option>
      </select>
    </div>
  );
};
